module.exports = __webpack_public_path__ + "static/media/quiz.2d78d303.png";